import { useState } from 'react';
import { api, setToken } from '../api';
import { storedTheme } from '../store';
import { themeStyle } from '../themes';
import { btn, mono, primary } from '../ui';

/** Вход в консоль. Показывается, только если на сервере задан CONSOLE_PASSWORD. */
export function Login({ onDone }: { onDone: () => void }) {
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [busy, setBusy] = useState(false);

  const submit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (busy) return;
    setBusy(true);
    setError('');
    try {
      const { token } = await api.login(password);
      setToken(token);
      onDone();
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Не удалось войти');
      setBusy(false);
    }
  };

  return (
    <div
      style={{
        ...themeStyle(storedTheme(), false),
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: 24,
        background: 'var(--bg)',
        color: 'var(--ink)',
        fontFamily: 'var(--fs)',
        fontSize: 13.5
      }}
    >
      <form
        onSubmit={submit}
        style={{
          width: 'min(360px, 100%)',
          boxSizing: 'border-box',
          display: 'flex',
          flexDirection: 'column',
          gap: 16,
          padding: '28px 26px',
          border: '1px solid var(--line)',
          borderRadius: 'var(--r)',
          background: 'var(--panel)'
        }}
      >
        <div style={{ display: 'flex', alignItems: 'center', gap: 11 }}>
          <span
            style={{
              width: 30,
              height: 30,
              flex: 'none',
              borderRadius: 'var(--rs)',
              background: 'var(--acc)',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              ...mono,
              fontSize: 13,
              fontWeight: 600,
              color: 'var(--accInk)'
            }}
          >
            F
          </span>
          <span style={{ display: 'flex', flexDirection: 'column', lineHeight: 1.25 }}>
            <span style={{ fontWeight: 600, fontSize: 14 }}>Fleet Console</span>
            <span style={{ fontSize: 11, color: 'var(--ink3)' }}>управление парком Windows</span>
          </span>
        </div>

        <label style={{ display: 'flex', flexDirection: 'column', gap: 7 }}>
          <span style={{ fontSize: 11.5, color: 'var(--ink3)' }}>Пароль консоли</span>
          <input
            className="focusAcc"
            type="password"
            autoFocus
            value={password}
            onChange={e => setPassword(e.target.value)}
            style={{
              boxSizing: 'border-box',
              padding: '10px 12px',
              borderRadius: 'var(--rs)',
              border: '1px solid var(--line)',
              background: 'var(--panel2)',
              color: 'var(--ink)',
              ...mono,
              fontSize: 13,
              outline: 'none'
            }}
          />
        </label>

        {error && <span style={{ fontSize: 12, color: 'var(--bad)' }}>{error}</span>}

        <button type="submit" className="bright" disabled={busy} style={{ ...primary, textAlign: 'center' }}>
          {busy ? 'Проверяю…' : 'Войти'}
        </button>

        <span style={{ fontSize: 11, color: 'var(--ink4)', lineHeight: 1.6 }}>
          Пароль задаётся переменной CONSOLE_PASSWORD на сервере. Сессия живёт 12 часов.
        </span>
      </form>
    </div>
  );
}

/** Кнопка выхода — прячется в подвале сайдбара только при включённом пароле. */
export function LogoutButton({ onClick }: { onClick: () => void }) {
  return (
    <button className="hovInk" onClick={onClick} style={{ ...btn, fontSize: 11, color: 'var(--ink4)' }}>
      Выйти
    </button>
  );
}
